import * as React from "react";
function SvgCritizr(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M24.11 15.3c-2.15 0-3.9.35-3.9.75s1.75.75 3.9.75 3.89-.34 3.89-.75-1.75-.75-3.89-.75zM23 11.09c1.9-1.09 3.25-2.25 3-2.61s-1.89.19-3.75 1.26S19 12 19.22 12.35s1.91-.2 3.78-1.26zm0 9.82c-1.87-1.07-3.57-1.63-3.75-1.27s1.17 1.54 3 2.61 3.56 1.64 3.75 1.27-1.1-1.52-3-2.61zM13.75 9.66a6.35 6.35 0 012.54.56l.25.11 2.66-2.71-.51-.32A9 9 0 0014 6a9.92 9.92 0 00-10 9.87v.22A9.85 9.85 0 0013.75 26a9.79 9.79 0 004.92-1.36l.49-.3-2.66-2.7-.26.12a5.94 5.94 0 01-2.55.58A6.14 6.14 0 017.75 16a6.2 6.2 0 016-6.34z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCritizr);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
